import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { MarketModel } from 'src_common/common/websocket2/models/MarketModel';
import {
    RaceSummaryCaptionHeader,
    RaceSummaryCaptionHeaderCast,
    RaceTableCaption,
    RunnerCaptionAntePost,
    SelectionAntePostSpecial,
} from 'src/domains/sportsbook/webview/components/raceSummary/raceSummarySport/horseRacing/HeadersHorseRacing.style';
import { useCommon } from 'src/domains/common/Common';
import { BreakpointsState } from 'src/domains/layouts/state/breakpointsState/BreakpointsState';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { TableHeaderCell } from 'src/ui/components/table/sports/row/hr-gr/event/custom/TableHeaderCell';

interface HeadersPropsType {
    isAntePost?: boolean;
    isPriceHistoryHidden?: boolean;
    isPriceOnly?: boolean;
    isSpecials?: boolean;
    market: MarketModel;
    type?: string;
}

export const HeadersHorseRacing = observer('HeadersHorseRacing', (props: HeadersPropsType) => {
    const common = useCommon();
    const breakpointsState = BreakpointsState.get(common);
    const configState = ConfigComponents.get(common).config;
    const { sportsbookVariant } = configState.componentVariants;
    const { isAntePost, isPriceHistoryHidden, isSpecials, market, type } = props;

    if (type === 'cast') {
        return (
            <RaceSummaryCaptionHeaderCast variant={sportsbookVariant}>
                <TableHeaderCell
                    isWide={true}
                    dataTest='race-summary-header-runner'
                >
                    <I18n
                        langKey='events.race-summary.runner.label'
                        defaultText='Runner'
                    />
                </TableHeaderCell>

                <TableHeaderCell
                    align='center'
                    dataTest='race-summary-header-1st'
                    mobileSize='48px'
                    tabletSize='63px'
                >
                    <I18n
                        langKey='events.race-summary.1st.label'
                        defaultText='1st'
                    />
                </TableHeaderCell>

                <TableHeaderCell
                    align='center'
                    dataTest='race-summary-header-2nd'
                    mobileSize='48px'
                    tabletSize='63px'
                >
                    <I18n
                        langKey='events.race-summary.2nd.label'
                        defaultText='2nd'
                    />
                </TableHeaderCell>

                {market.tricastsOffered ? (
                    <TableHeaderCell
                        align='center'
                        dataTest='race-summary-header-3rd'
                        mobileSize='48px'
                        tabletSize='63px'
                    >
                        <I18n
                            langKey='events.race-summary.3rd.label'
                            defaultText='3rd'
                        />
                    </TableHeaderCell>
                ) : (
                    ''
                )}

                <TableHeaderCell
                    align='center'
                    dataTest='race-summary-header-anyorder'
                    mobileSize='48px'
                    tabletSize='63px'
                >
                    <I18n
                        langKey='events.race-summary.any-order.label'
                        defaultText='Any Order'
                    />
                </TableHeaderCell>
            </RaceSummaryCaptionHeaderCast>
        );
    }

    if (isAntePost === true) {
        return (
            <RaceTableCaption variant={sportsbookVariant}>
                <RunnerCaptionAntePost>
                    <I18n
                        langKey='events.race-summary.runner.label'
                        defaultText='Runner'
                    />
                </RunnerCaptionAntePost>

                <SelectionAntePostSpecial variant={sportsbookVariant}>
                    <I18n
                        langKey='events.race-summary.price.label'
                        defaultText='Price'
                    />
                </SelectionAntePostSpecial>
            </RaceTableCaption>
        );
    }

    if (isSpecials === true) {
        return null;
    }

    return (
        <RaceSummaryCaptionHeader variant={sportsbookVariant}>
            <TableHeaderCell isWide={true}>
                <I18n
                    langKey='events.race-summary.runner.label'
                    defaultText='Runner'
                />
            </TableHeaderCell>

            {isPriceHistoryHidden === true ? null : (
                <TableHeaderCell
                    align='center'
                    mobileSize='76px'
                    tabletSize='108px'
                >
                    <I18n
                        langKey='events.race-summary.price-history.label:new-racecard'
                        defaultText='History'
                    />
                </TableHeaderCell>
            )}

            <TableHeaderCell
                align='center'
                mobileSize='48px'
                tabletSize='63px'
            >
                <I18n
                    langKey='events.race-summary.price.label'
                    defaultText='Price'
                />
            </TableHeaderCell>
            {breakpointsState.tablet.isBiggerOrEq === false || props.isPriceOnly === true ? (
                ''
            ) : (
                <TableHeaderCell
                    align='center'
                    mobileSize='48px'
                    tabletSize='63px'
                >
                    SP
                </TableHeaderCell>
            )}
        </RaceSummaryCaptionHeader>
    );
});
